import React, { useEffect, useState } from "react";
import { X } from "@phosphor-icons/react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function ExitIntentPopup() {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");

  useEffect(() => {
    if (sessionStorage.getItem("bm_exit_seen")) return;
    const handler = (e) => {
      if (e.clientY < 8) {
        setOpen(true);
        sessionStorage.setItem("bm_exit_seen", "1");
      }
    };
    document.addEventListener("mouseleave", handler);
    return () => document.removeEventListener("mouseleave", handler);
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/newsletter", { email }); toast.success("Code WELCOME10 unlocked"); setOpen(false); }
    catch { toast.error("Invalid email"); }
  };

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center px-4" onClick={()=>setOpen(false)} data-testid="exit-intent-popup">
      <div className="bg-white rounded-3xl max-w-md w-full p-10 relative" onClick={e=>e.stopPropagation()}>
        <button onClick={()=>setOpen(false)} className="absolute top-4 right-4" data-testid="exit-popup-close"><X size={18} weight="thin"/></button>
        <div className="eyebrow">Exclusive</div>
        <h3 className="font-serif-bm text-3xl mt-3">Wait — 10% Off Your First Order</h3>
        <p className="text-sm text-[var(--bm-muted)] mt-3 leading-relaxed">Join Boom Mode and receive a private offer for first-time customers, plus early access to new pieces.</p>
        <form onSubmit={submit} className="mt-6 space-y-3">
          <input className="bm-input" placeholder="your@email.com" value={email} onChange={e=>setEmail(e.target.value)} required type="email" data-testid="exit-popup-email"/>
          <button className="btn-primary w-full justify-center" data-testid="exit-popup-submit">Unlock 10% off</button>
        </form>
        <p className="text-[10px] tracking-widest uppercase text-center mt-4 text-[var(--bm-muted)]">No spam · unsubscribe anytime</p>
      </div>
    </div>
  );
}
